export const AREA_COLORS = { body: "#1F4266", mind: "#0EA5E9", spirit: "#14A38B", self: "#E8A33D", others: "#E4572E" };

export const MAX_SCORE = 36;

export const AREAS = [
  { key: "body", label: "Body", angle: -90 },
  { key: "mind", label: "Mind", angle: -21 },
  { key: "spirit", label: "Spirit", angle: 52 },
  { key: "self", label: "Self", angle: 128 },
  { key: "others", label: "Others", angle: 204 },
];

export const LEVELS = [
  { label: "Be Centered", min: 0, max: 11, hex: "#E4572E" },
  { label: "Be Grounded", min: 12, max: 20, hex: "#E8A33D" },
  { label: "Be Secure", min: 21, max: 28, hex: "#14A38B" },
  { label: "Be Love", min: 29, max: 36, hex: "#1F4266" },
];

const GRADIENT = [
  [0, "#E4572E"],
  [12 / 36, "#E8A33D"],
  [21 / 36, "#14A38B"],
  [29 / 36, "#2563EB"],
  [1, "#1F4266"],
];

const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
const GRAD_RGB = GRADIENT.map(([at, hex]) => [at, rgb(hex)]);
export const GRADIENT_CSS = `linear-gradient(90deg, ${GRADIENT.map(([at, h]) => `${h} ${Math.round(at * 100)}%`).join(",")})`;

export function heatRgb(t) {
  const x = Math.max(0, Math.min(1, t));
  let i = 0;
  while (i < GRAD_RGB.length - 2 && x > GRAD_RGB[i + 1][0]) i++;
  const [a0, a] = GRAD_RGB[i];
  const [a1, b] = GRAD_RGB[i + 1];
  const f = (x - a0) / (a1 - a0);
  return [0, 1, 2].map((k) => Math.round(a[k] + (b[k] - a[k]) * f));
}

export function band(score) {
  const s = Math.round((Number(score) || 0) * 100) / 100;
  return [...LEVELS].reverse().find((b) => s >= b.min) || LEVELS[0];
}

export const total = (scores) => AREAS.reduce((s, a) => s + (Number(scores?.[a.key]) || 0), 0);
export const average = (scores) => total(scores) / AREAS.length;

export function ageFrom(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d)) return null;
  const n = new Date();
  let age = n.getFullYear() - d.getFullYear();
  if (n.getMonth() < d.getMonth() || (n.getMonth() === d.getMonth() && n.getDate() < d.getDate())) age -= 1;
  return age;
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "—";

export const fmtScore = (v) => (Number.isInteger(Number(v)) ? String(Number(v)) : Number(v).toFixed(1));
